import React, { useContext } from 'react';
import Button from '@material-ui/core/Button';
import moment from 'moment-timezone';
import { isNumber } from 'lodash-es';
import { makeStyles } from '@material-ui/core/styles';
import { formatPostDate } from '@mummssoftware/utils/formatters';
import { GlobalContext } from '@mummssoftware/global-context/GlobalContext';
import { Context } from '../../context';
import { DateContext } from '../../containers/Measures';
import {
  SET_LOADER,
  SET_SCORES_METHOD,
  RESET_SCORES,
  SET_ALL_VALUES_ENTERED,
  scoresType,
  ObservationMethod,
} from '../../containers/MeasuresContext/utils/constants';
import { MeasuresContext } from '../../containers/MeasuresContext/MeasuresContextProvider';
import defaults from '../../translations/en.json';

const useStyles = makeStyles((theme) => ({
  focused: {
    padding: '2px 5px',
    margin: 5,
    backgroundColor: (theme.palette as any).graph.graphColor,
    color: theme.palette.common.black,
    '&:hover': {
      backgroundColor: (theme.palette as any).graph.graphColor,
      color: theme.palette.common.black,
    },
  },
}));

export const SubmitESAS = () => {
  const classes = useStyles();
  const {
    dispatch,
    allValuesEntered,
    methodSelected,
    scoresState,
    anyValueEntered,
  } = useContext(MeasuresContext);
  const { updateDate, setUpdateDate } = useContext(DateContext);
  const { handleMeasureChange, patient, currentUser } = useContext(Context);
  const { appVisit, patientDateRestrictions } = useContext(GlobalContext);
  const patientNumber = patient?.patientNumber;
  const patientSiteId = patient?.siteId.toString();
  const patientId = patient?.id;
  const personId = currentUser.isMumms ? null : currentUser.userId;

  const recordingIndividually =
    methodSelected === ObservationMethod.INDIVIDUALLY;
  // Disabled if (no value entered) or ((not recording individually) and (some values not entered))
  const disabled =
    !anyValueEntered || (!recordingIndividually && !allValuesEntered);

  const onClick = () => {
    dispatch({
      type: SET_LOADER,
      payload: true,
    });
    submitForm();
  };

  // eslint-disable-next-line consistent-return
  const submitForm = async () => {
    type Score = mumms.measure;

    const tz = currentUser.siteTimezone || moment.tz.guess();
    const date = formatPostDate(updateDate);
    const scores: any = [];

    // @note VISIT if a visit is being recorded save date and id
    const patientvisitId = appVisit ? appVisit.id : null;
    const visitdatetime = appVisit ? appVisit.effectivedatetime : null;

    try {
      // TODO: UPDATE THIS TO THE BULK ENDPOINT CALL INSTEAD OF A LOOP
      Object.keys(scoresState).forEach((measure: any) => {
        const measureName = measure;
        const scoreValue = scoresState[measure];
        const score: Score = {
          id: '',
          comments: '',
          displayalue: '',
          measurecategoryshortname: scoresType,
          measuredate: '',
          measuredatetime: date,
          measuredatetimeshifted: '',
          measuretypeid: '',
          measuretypename: '',
          measuretypeshortname: measureName,
          missingreason: '',
          observationmethod: methodSelected as string,
          patientid: (patientId as number).toString() as string,
          patientnumber: patientNumber as string,
          personid: personId as string,
          personcredentials: '',
          personfirstname: '',
          personlastname: '',
          personnumber: '',
          siteid: patientSiteId as string,
          timezone: tz,
          units: '',
          value: scoreValue as string,
          value2: '',
          enteredvalue: '',
          patientvisit_id: patientvisitId,
          visitdatetime,
        };
        if (isNumber(scoreValue) || typeof scoreValue === 'string') {
          scores.push(score);
        }
      });

      await handleMeasureChange(
        patientNumber as string,
        scores,
        'POST',
        scoresType,
      ).catch((e) => {
        console.error('e', e);
        // eslint-disable-next-line no-shadow
      });

      dispatch({
        type: SET_LOADER,
        payload: false,
      });
      dispatch({
        type: SET_SCORES_METHOD,
        payload: null,
      });
      dispatch({
        type: RESET_SCORES,
      });
      dispatch({
        type: SET_ALL_VALUES_ENTERED,
        payload: false,
      });
      // TODO: Add response validation
    } catch (ex) {
      return false;
    }
  };

  return (
    <>
      <Button
        type="submit"
        variant="contained"
        size="small"
        className={classes.focused}
        disabled={disabled}
        onClick={onClick}
      >
        {defaults.submit}
      </Button>
    </>
  );
};
